import React from 'react';
import { useParams } from 'react-router-dom';
import FormAddEditPostCategory from '../../../components/blog/categories/FormAddEditPostCategory';
import { useGetPostCategoryById } from '../../../hooks/blog/categories/useGetPostCategoryById';
import LoadingSpinner from '../../../components/global/LoadingSpinner';
import ErrorAlert from '../../../components/global/ErrorAlert';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const EditPostCategory = () => {
    const { id } = useParams();
    const { category, isLoading, error } = useGetPostCategoryById(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <LoadingSpinner />
            </WrapperSection>
        );
    }
    if (error) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <ErrorAlert error={error} />
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPostCategory currentData={category} isEdit={true} />
        </WrapperSection>
    );
};

export default EditPostCategory;
